import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getPermissions, getCompany, getSubcompany } from 'auth/selectors';
import ProvidersList from 'providers/components/list';

class ProvidersRowContainer extends Component {
  render = () => (
    <ProvidersList.Row
      handleToggle={this.props.handleToggle}
      company={this.props.company}
      subcompany={this.props.subcompany}
      provider={this.props.provider}
      permissions={this.props.permissions}
    />
  );
}

const mapStateToProps = (state) => ({
  company: getCompany(state),
  subcompany: getSubcompany(state),
  permissions: getPermissions(state),
});

export default connect(mapStateToProps, null)(ProvidersRowContainer);



// WEBPACK FOOTER //
// src/modules/secured/modules/providers/containers/ProvidersRowContainer.js